import { render } from "./list-sub-dis-set-dialog.vue?vue&type=template&id=6e069c9c&scoped=true&ts=true"
import script from "./list-sub-dis-set-dialog.vue?vue&type=script&lang=ts"
export * from "./list-sub-dis-set-dialog.vue?vue&type=script&lang=ts"

import "./list-sub-dis-set-dialog.vue?vue&type=style&index=0&id=6e069c9c&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e069c9c"]])

export default __exports__